import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CountersService {
	readonly numberOfUnreadInboxMessages = signal(0);

	updateUnReadInboxMessagesCounter(numberOfUnreadInboxMessages: number): void {
    this.numberOfUnreadInboxMessages.set(numberOfUnreadInboxMessages);
  } 
}